module.exports = __webpack_public_path__ + "img/icon-63.d17f42a5.png";